import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {CreateOrderComponent} from './create-order/create-order.component';
import {CreatePartnerComponent} from './create-partner/create-partner.component';
import {CreateCustomerComponent} from './create-customer/create-customer.component';
import {CreateSubscriptionComponent} from './create-subscription/create-subscription.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ViewOrdersComponent} from './view-orders/view-orders.component';
import {ViewCustomersComponent} from './view-customers/view-customers.component';
import {ViewPartnersComponent} from './view-partners/view-partners.component';
import {ViewSubscriptionsComponent} from './view-subscriptions/view-subscriptions.component';
import {ManageOrderComponent} from './manage-order/manage-order.component';
import {ManageCustomerComponent} from './manage-customer/manage-customer.component';
import {ManagePartnerComponent} from './manage-partner/manage-partner.component';
import {ManageSubscriptionComponent} from './manage-subscription/manage-subscription.component';
import {CreateUserComponent} from "./create-user/create-user.component";
import {ViewUsersComponent} from "./view-users/view-users.component";
import {ManageUserComponent} from "./manage-user/manage-user.component";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import {SkySwitchLoginComponent} from './skyswitch-login/skyswitch-login.component';
import {SkyswitchSsoComponent} from './skyswitch-sso/skyswitch-sso.component';

const routes: Routes = [
  { path: '', redirectTo: '/create/order', pathMatch: 'full' },
  { path: 'create/order', component: CreateOrderComponent},
  { path: 'create/partner', component: CreatePartnerComponent},
  { path: 'create/customer', component: CreateCustomerComponent},
  { path: 'create/subscription', component: CreateSubscriptionComponent},
  { path: 'create/user', component: CreateUserComponent},
  { path: 'view/orders', component: ViewOrdersComponent},
  { path: 'view/customers', component: ViewCustomersComponent},
  { path: 'view/partners', component: ViewPartnersComponent},
  { path: 'view/subscriptions', component: ViewSubscriptionsComponent},
  { path: 'view/users', component: ViewUsersComponent},
  { path: 'manage/order', component: ManageOrderComponent},
  { path: 'manage/customer', component: ManageCustomerComponent},
  { path: 'manage/partner', component: ManagePartnerComponent},
  { path: 'manage/subscription', component: ManageSubscriptionComponent},
  { path: 'manage/user', component: ManageUserComponent},
  { path: 'account/changepwd', component: ChangePasswordComponent},
  { path: 'pbx/login', component: SkySwitchLoginComponent},
  { path: 'pbx/sso', component: SkyswitchSsoComponent},
  { path: 'login', component: LoginComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts